import { el, clear, onTeardown } from '../lib/dom.js';
import { loadSnapshot } from '../data/snapshot.js';
import { settings } from '../store/settings.js';
import { ui } from '../store/ui.js';
import { Sprite } from '../components/Sprite.js';
import { CompareTable } from '../components/CompareTable.js';
import { openPokemonPicker } from '../components/PokemonPicker.js';

const MAX = 4;

export async function CompareView() {
  const view = el('section', { class: 'view lookup compareview' });
  const snap = await loadSnapshot();
  const vg = snap.versionGroupByKey.get(settings.get().versionGroup);
  const gen = vg ? vg.generation : 9;

  let ids = (ui.get().compareIds || []).filter((id) => snap.speciesById.get(id)).slice(0, MAX);
  const persist = () => ui.set({ compareIds: ids });

  const slots = el('div', { class: 'lineup' });
  const body = el('div', { class: 'compareview__body' });

  function render() {
    const style = settings.get().spriteStyle;
    const mem = ids.map((id) => snap.speciesById.get(id)).filter(Boolean);

    clear(slots);
    for (const sp of mem) {
      slots.append(
        el(
          'div',
          { class: 'lineup__slot' },
          el(
            'button',
            {
              class: 'lineup__x',
              type: 'button',
              'aria-label': `Remove ${sp.name}`,
              onclick: () => {
                ids = ids.filter((x) => x !== sp.id);
                persist();
                render();
              },
            },
            '✕',
          ),
          el(
            'a',
            { href: `#/pokemon/${sp.id}`, class: 'lineup__link' },
            Sprite(sp.id, { style, alt: sp.name, size: 64 }),
            el('span', { class: 'lineup__name' }, sp.name.replace(/-/g, ' ')),
          ),
        ),
      );
    }
    if (mem.length < MAX) {
      slots.append(
        el(
          'button',
          {
            class: 'lineup__add',
            type: 'button',
            onclick: () =>
              openPokemonPicker((id) => {
                if (ids.includes(id) || ids.length >= MAX) return;
                ids = [...ids, id];
                persist();
                render();
              }),
          },
          '＋',
          el('span', {}, 'Add'),
        ),
      );
    }
    if (mem.length) {
      slots.append(
        el(
          'button',
          {
            class: 'lineup__clear',
            type: 'button',
            onclick: () => {
              ids = [];
              persist();
              render();
            },
          },
          'Clear',
        ),
      );
    }

    clear(body);
    body.append(
      mem.length >= 2
        ? CompareTable(mem, { gen, style })
        : el(
            'p',
            { class: 'detail__muted' },
            'Add two or more Pokémon to compare their types and base stats.',
          ),
    );
  }

  clear(view).append(
    el('nav', { class: 'lookup__nav' }, el('a', { class: 'link', href: '#/team' }, '‹ Team')),
    el(
      'header',
      { class: 'view__header' },
      el('h1', {}, 'Compare'),
      el('p', {}, vg ? `Types shown for ${vg.name}.` : 'Types shown for the newest games.'),
    ),
    slots,
    body,
  );
  render();

  const offSettings = settings.subscribe(render);
  onTeardown(view, () => offSettings());
  return view;
}
